<div class="d-flex">
  <div class="arrow" [class.d-none]="!enableBtn" (click)="scrollRight()">
    <i class="icon-chevron_right-o"></i>
  </div>

  <ul class="tabset" #tabset>
    <li
      *ngFor="let tab of tabs; let index = index"
      (click)="selectTab(tab, index); $event?.preventDefault()"
      (keyup.space)="selectTab(tab, index)"
      (keyup.enter)="selectTab(tab, index)"
      [class.responsive]="tab.responsive"
      [class.active]="tab.active"
      [class.tabactive]="isTabsetRouter === 'true'"
      [class.disabled]="tab.disabled"
      [attr.tabindex]="tab.disabled ? -1 : 0"
      class="tab"
      (auxclick)="
        isTabsetRouter === 'true' ? closeTab(index) : $event.preventDefault();
        isTabsetRouter === 'true' ? $event.preventDefault() : $event.preventDefault()
      ">
      <span tabindex="-1">
        {{ tab.tabTitle | translate }}
      </span>
      <i class="icon-close-o" *ngIf="tab.isCloseable && !tab.disabled" (click)="closeTab(index); $event?.preventDefault()"> </i>
    </li>
  </ul>
  <div class="arrow" [class.d-none]="!enableBtn" (click)="scrollLeft()">
    <i class="icon-chevron_left-o"></i>
    <div class="border"></div>
  </div>
  <div class="close-all" *ngIf="isTabsetRouter === 'true'">
    <i class="icon-close-o" [title]="'ClientApp.Projects.FrameWorkShell.Tabular.CloseAllTabs' | translate" (click)="closeAllTabs()"> </i>
  </div>
</div>
<ng-content select="ssg-tab"></ng-content>
